module.exports = __webpack_public_path__ + "img/NewsCenterDetails4_pic8.14a47e09.png";